const getApiBaseUrl = () => {
  const envUrl = import.meta.env.VITE_API_URL ?? '/api';
  let normalizedUrl = envUrl.replace(/0\.0\.0\.0/g, 'localhost');
  const isPrivateNetwork = /192\.168\.\d+\.\d+|10\.\d+\.\d+\.\d+|172\.(1[6-9]|2[0-9]|3[0-1])\.\d+\.\d+/.test(normalizedUrl);
  if (normalizedUrl.startsWith('http://') && !normalizedUrl.includes('localhost') && !normalizedUrl.includes('127.0.0.1') && !isPrivateNetwork) {
    normalizedUrl = normalizedUrl.replace('http://', 'https://');
  }
  return normalizedUrl;
};

const API_BASE_URL = getApiBaseUrl();

function getHeaders(): Record<string, string> {
  return { 'Content-Type': 'application/json' };
}

/**
 * A credencial vai no cookie de sessão HttpOnly (RG-05), que o navegador só
 * envia com `credentials: 'include'`.
 */
async function request<T = any>(method: string, path: string, body?: any): Promise<{ success: boolean; data?: T; message?: string }> {
  const res = await fetch(`${API_BASE_URL}/portal${path}`, {
    method,
    headers: getHeaders(),
    credentials: 'include',
    body: body ? JSON.stringify(body) : undefined,
  });
  return res.json();
}

// ==========================================
// Portal API (role: cliente)
// ==========================================

export const portalApi = {
  // Apreciacoes
  listarApreciacoes: () => request('GET', '/apreciacoes'),
  buscarApreciacao: (id: string) => request('GET', `/apreciacoes/${id}`),
  obterPdfBlob: async (id: string): Promise<Blob | null> => {
    const res = await fetch(`${API_BASE_URL}/portal/apreciacoes/${id}/pdf`, {
      headers: getHeaders(),
      credentials: 'include',
    });
    if (!res.ok) return null;
    return res.blob();
  },

  // Anotacoes
  listarAnotacoes: (apreciacaoId: string, pagina?: number) => {
    const query = pagina !== undefined ? `?pagina=${pagina}` : '';
    return request('GET', `/apreciacoes/${apreciacaoId}/anotacoes${query}`);
  },
  criarAnotacao: (apreciacaoId: string, dados: { pagina: number; posX: number; posY: number; texto: string; tipo?: string }) =>
    request('POST', `/apreciacoes/${apreciacaoId}/anotacoes`, dados),
  responderAnotacao: (anotacaoId: string, texto: string) =>
    request('POST', `/anotacoes/${anotacaoId}/respostas`, { texto }),
  resolverAnotacao: (anotacaoId: string) =>
    request('PUT', `/anotacoes/${anotacaoId}/resolver`),

  // Aprovacao
  aprovarApreciacao: (apreciacaoId: string, observacoes?: string) =>
    request('POST', `/apreciacoes/${apreciacaoId}/aprovar`, { observacoes }),
  solicitarRevisao: (apreciacaoId: string, observacoes: string) =>
    request('POST', `/apreciacoes/${apreciacaoId}/solicitar-revisao`, { observacoes }),

  // Perfil
  obterPerfil: () => request('GET', '/perfil'),
};

// ==========================================
// Admin API (compartilhamento)
// ==========================================

async function adminRequest<T = any>(method: string, path: string, body?: any): Promise<{ success: boolean; data?: T; message?: string }> {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: getHeaders(),
    credentials: 'include',
    body: body ? JSON.stringify(body) : undefined,
  });
  return res.json();
}

export const compartilhamentoApi = {
  compartilhar: (apreciacaoId: string, empresaId: string) =>
    adminRequest('POST', `/apreciacoes/${apreciacaoId}/compartilhar`, { empresaId }),
  revogar: (apreciacaoId: string, empresaId: string) =>
    adminRequest('DELETE', `/apreciacoes/${apreciacaoId}/compartilhar/${empresaId}`),
  listar: (apreciacaoId: string) =>
    adminRequest('GET', `/apreciacoes/${apreciacaoId}/compartilhamentos`),
  listarAnotacoes: (apreciacaoId: string) =>
    adminRequest('GET', `/apreciacoes/${apreciacaoId}/anotacoes-cliente`),
  responderAnotacao: (anotacaoId: string, texto: string) =>
    adminRequest('POST', `/anotacoes/${anotacaoId}/respostas`, { texto }),
  resolverAnotacao: (anotacaoId: string) =>
    adminRequest('PUT', `/anotacoes/${anotacaoId}/resolver`),
};
